import { Component, OnInit } from '@angular/core';
import * as backInter from 'app/auth/auth-data.model';
import { LandingService } from "app/main/pagina/landingProducto/landingFocus/landing.service";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_focus } from 'app/idiomas/i18n/focus/focus.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import { ODSService } from 'app/main/pagina/tools/gestUsu/services/ods.service';
import * as catSecciones from 'app/main/pagina/tools/gestUsu/detail/cat-secciones';
import { MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalAgregarEncComponent } from "app/main/pagina/landingProducto/landing/admin-pulsecheck/modal-agregar-enc/modal-agregar-enc.component";

@Component({
  selector: 'control-encuestas',
  templateUrl: './control-encuestas.component.html',
  styleUrls: ['./control-encuestas.component.scss']
})
export class ControlEncuestasComponent implements OnInit {
  idiomaActual:string;
  mensajesTraducirTS = {
    error1: '',
    error2: ''
  };
  mensajesTraducirKeys: string[] = [
    'SHEDULE.ERRORDATE',
    'SHEDULE.SAMEDATE'
  ];
  mostrarEncuestas: backInter.getEncuestasFocus;
  mostrarEncuestasFocus3: any;

    // displayedColumns: string[] = ['validacion','nameEncuesta', 'fechaInicio', 'fechaCerrar','estado','accion'];
    displayedColumns: string[] = ['nameEncuesta', 'fechaInicio', 'fechaCerrar','estado','accion'];
    url='companies/detail/'+localStorage.getItem('empresaID');
    cargando = true;
    Autorizado=false;
    banderaEncuestaFocus: backInter.actualizaBanderaFocus;
    productosContratadosInter : backInter.infoProductos;
    statusDefault= false;
    tipoVersionFocus:string;
    listaProdsFocus: any[] = [];
    idsProductosCert3Falsos = [
      {id:41, activo: false}, // medir 3.0
      {id:42, activo: false}, // pulse check 3.0
      {id:43, activo: false}, // pulse check 3.0
    ];

    aniosPulsecheck:any[]=[];
    btnPortalConteos:boolean= false;
    anioseleccionado:any;
    ShowEditTable:boolean=false;
    EditRowID:any='';
    nameSurvey:any='';
  constructor(
    private landingService : LandingService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private router: Router,
    private activatedRoute : ActivatedRoute,
    private adicionalesAdminService: AdicionalesService,
    private odsService: ODSService,
    private dialog: MatDialog,
  ) {
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_focus.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });


   }

  ngOnInit() {
this.tipoVersionFocus=localStorage.getItem('version')
this.anioseleccionado= localStorage.getItem('fechaProducto');
console.log('tipo de focus ',localStorage.getItem('version'));
if (this.tipoVersionFocus=='version3') {
  this.getProductsByCompany();
}else{
  this.getEncuestasAll();
}
    this.traduceTextosTS();
}

edit(val,nameSurvey){
  this.EditRowID=val;
  this.nameSurvey=nameSurvey
}


editNameSurvey(event,idProducto){
  if (this.nameSurvey== event.target.value) {
    console.log('no hace nada por que es el mismo  texto ');
    this.EditRowID='';
  }else{
    console.log('idProducto',idProducto);
    console.log('event',event.target.value);
  this.modalGuardado();
    console.log('se modifica por que es nuevo el nameSurvey ');
    this.odsService.cambiarNombreEncuestaFocus(idProducto,event.target.value).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.EditRowID='';
      Swal.close();
      this.getProductsByCompany();
    }, error => {
      console.log("error", error);
    })









  }

}


modalGuardado(){
    Swal.fire({
    title: this.translateSrv.instant('CONSULTATABLA.UPDATE_NAME_SURVEY'),
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading()
    }
  });
}

private getProductsByCompany() {
  this.odsService.getProductosEmpresa(localStorage.getItem('empresaID')).subscribe((respuesta:backInter.infoProductos) => {
    console.log(respuesta);
    this.productosContratadosInter = respuesta;
    // this.listaProdsFocus = [];
    // let arrayFocus_1:any[] = [];
    // let data:any;
    this.encuestasfocus3();
    // this.productosContratadosInter.productosCertificar.forEach((producto:any) => {
    //     switch (producto.idProducto) {
    //       case 43:  //focus 3.0
    //       console.log('productoFocus');
    //       arrayFocus_1.push(producto);
    //       break;
    //     }
    // });
    // data=arrayFocus_1;
    // // this.mostrarEncuestasFocus3=arrayFocus_1;
    // // this.cargando= false;
    // console.log('arrayFocus_1',this.mostrarEncuestasFocus3);
  }, error => {
    console.log("error", error);
  })
}

  traduceTextosTS(){
   let iter = 0;
   for(var k in this.mensajesTraducirTS){
     this.translateSrv.get(this.mensajesTraducirKeys[iter]).subscribe((res: string) => {
       //console.log(k);
       this.mensajesTraducirTS[k] = res;
       // console.log(this.mensajesTraducirTS[k]);
     });
     iter++;
   }
   this.idiomaActual = this.translateSrv.currentLang;


 }


  getEncuestasAll(){
      let data:any = {productoId: localStorage.getItem('productoID')}
      this.landingService.getMostrarEncuestasOds(localStorage.getItem('empresaID'),data).subscribe((respuesta:backInter.getEncuestasFocus) => {
        console.log(respuesta);
        this.mostrarEncuestas = respuesta;
        this.cargando= false;
        this.mostrarEncuestas.data.forEach(element => {
          if (element.estatusVerificacion==6 || element.estatusVerificacion==2 || element.estatusVerificacion==3) {
          element.statusEncuesta= true;
          console.log(element.statusEncuesta);

          }else{
            element.statusEncuesta= false;
            console.log(element.statusEncuesta);
            console.log("No encontro");
          }

        });
      }, error => {
        console.log(error);
      });
    }


  nombreEncuesta(){
    this.EditRowID='';
      let texto = 'LANDINFOCUS.MODALES.CREARENC';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      let rspAceptar = 'LANDINFOCUS.MODALES.RSPACEPTAR';
      this.translateSrv.get(rspAceptar).subscribe((res: string) => { rspAceptar = res; });

  Swal.fire({
  title: texto,
  input: 'text',
  inputAttributes: {
    autocapitalize: 'off'
  },
  showCancelButton: true,
reverseButtons: true,
  confirmButtonText: rspAceptar,
  showLoaderOnConfirm: true,

  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.value) {
  let data:any;


if (this.tipoVersionFocus=='version3') {
  data = {
    productoId: 43,
    fechaProducto: this.anioseleccionado,
    secciones : catSecciones.seccionesFocusArea3,
    nombreProducto:'focus 1',
    nameSurvey:result.value,
  };
    console.log(data);
  this.odsService.matchCompanyProduct(localStorage.getItem('empresaID'),data).subscribe((respuesta:any) => {
    console.log(respuesta);
    let modal = 'LANDINFOCUS.MODALES.CORRECTO';
    this.translateSrv.get(modal).subscribe((res1: string) => { modal = res1; });

    Swal.fire({
      title: modal + result.value
    })
    this.getProductsByCompany();
  }, error => {
    console.log(error);
  });
}else{
  this.landingService.AddNombreOds(localStorage.getItem('empresaID'),data).subscribe((respuesta:any) => {
    console.log(respuesta);
    let modal = 'LANDINFOCUS.MODALES.CORRECTO';
    this.translateSrv.get(modal).subscribe((res1: string) => { modal = res1; });

    Swal.fire({
      title: modal + result.value
    })
    // this.resultadoConteo = respuesta;
    this.getEncuestasAll();
  }, error => {
    console.log(error);
  });
}

  }
})
 }


 // eliminarEncuesta(idencuesta:any){
 //   let texto = 'LANDINFOCUS.MODALES.DELETE';
 //   this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
 //   let rspSi = 'LANDINFOCUS.MODALES.RSPSI';
 //   this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
 //   let rspNo = 'LANDINFOCUS.MODALES.RSPNO';
 //   this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
 //   let rspOk = 'LANDINFOCUS.MODALES.RSPOK';
 //   this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });
 //
 //   Swal.fire({
 //     /*title: 'Are you sure?',*/
 //     title: texto,
 //     icon: 'warning',
 //     showCancelButton: true,
 //     
 //     
 //     confirmButtonText: rspSi,
 //     cancelButtonText: rspNo,
 //   }).then((result) => {
 //     if (result.value) {
 //       let data:any = {encuestaID:idencuesta}
 //      this.landingService.eliminarEncuestaOds(localStorage.getItem('empresaID'),data).subscribe((respuesta:any) => {
 //        console.log(respuesta);
 //          this.getEncuestasAll();
 //          let modal = 'LANDINFOCUS.MODALES.COMDELETE';
 //          this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });
 //
 //          Swal.fire({
 //            icon: 'success',
 //            title: modal,
 //            
 //            confirmButtonText: rspOk,
 //          });
 //
 //      }, error => {
 //        console.log(error);
 //      });
 //
 //     }
 //   });
 //   // this.idPreguntaBorrar.emit(this.idPregunta);
 // }

 eliminarEncuesta(productId){
   let texto = 'LANDINFOCUS.MODALES.DELETE';
   this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
   let rspSi = 'LANDINFOCUS.MODALES.RSPSI';
   this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
   let rspNo = 'LANDINFOCUS.MODALES.RSPNO';
   this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
   let rspOk = 'LANDINFOCUS.MODALES.RSPOK';
   this.translateSrv.get(rspOk).subscribe((res: string) => { rspOk = res; });

   Swal.fire({
     /*title: 'Are you sure?',*/
     title: texto,
     icon: 'warning',
     showCancelButton: true,
reverseButtons: true,
     
     
     confirmButtonText: rspSi,
     cancelButtonText: rspNo,
   }).then((result) => {
     if (result.value) {

 this.odsService.deleteProductCompany(localStorage.getItem('empresaID'),productId).subscribe((respuesta:any) => {
   console.log(respuesta);
   let modal = 'LANDINFOCUS.MODALES.COMDELETE';
   this.translateSrv.get(modal).subscribe((res: string) => { modal = res; });

   Swal.fire({
     icon: 'success',
     title: modal,
     
     confirmButtonText: rspOk,
   });

   this.getProductsByCompany();
 }, error => {
   console.log(error);
 });
}
});

}

 setValidarEncuesta(accion:any, idEncuesta:any,encuNombre:string){
   if (accion.checked==true) {
     let datos={estatusVerificacion:6}
     this.adicionalesAdminService.actulizaBanderaEncuestaFocusPrincipal(datos,idEncuesta).subscribe( (data: any) => {
       console.log(data);
       this.getEncuestasAll();
       });
   }else if(accion.checked==false){
   let datos={estatusVerificacion:1}
   this.adicionalesAdminService.actulizaBanderaEncuestaFocusPrincipal(datos,idEncuesta).subscribe( (data: any) => {
     console.log(data);
     this.getEncuestasAll();
     });
   }

 }

 navigateToEncuestas(ruta,idEncuesta){
localStorage.setItem('encuestaID', idEncuesta);
this.router.navigate([ruta]);
 }

encuestasfocus3(){
  let moment = require('moment')
   let encuestaActiva:string;
   let fechaActualC = moment().format('YYYY/MM/DD');
     let fechaActual:number;
     let fechaPulse:any[]=[];
     let pulseV3:any[]=[];
 this.productosContratadosInter.productosCertificar.forEach((element) => {
 if (element.idProducto==43) {
 pulseV3.push(element);
 }
 });

     pulseV3.sort( (a,b) => {
       if(a.fechaCertificar > b.fechaCertificar){
         return 1;
       } else{
         return -1;
       }
     });
     console.log(pulseV3);


     pulseV3.forEach((element,i) => {
       console.log('element',element);
 // if(element.fechaCertificar==2019) {

   let datosPulsechek:any={};
   console.log(element.completoCertificar);

   let fechaLanzamiento= moment(element.fechaLanzamiento).format('YYYY/MM/DD');
   let fechaPortal= moment(fechaLanzamiento).isBefore(moment(fechaActualC));
   if(fechaPortal){
     console.log("econtro 1");
     this.btnPortalConteos=true;
   }else{
     this.btnPortalConteos=false;
   }
   console.log('surveyProductId');
   if(fechaActual){
     datosPulsechek={
       completoCertificar: element.completoCertificar,
       fechaLanzamiento: element.fechaLanzamiento,
       fechaCertificar: element.fechaCertificar,
       idPlantilla: element.idPlantilla,
       idCertificar: element.idCertificar,
       idSurvey: element.idSurvey,
       tokenConfig: element.tokenConfig,
       btnPortalConteos:this.btnPortalConteos,
       encuestaActiva:element.openSurvey,
       numPulse:element.numPulse,
       nameSurvey:element.nameSurvey,
     }

     console.log(datosPulsechek);

     if(element.fechaCertificar == fechaActual){
       // fechaPulse.push(element);
       fechaPulse.push(datosPulsechek);
     }
     else {
       this.aniosPulsecheck.push({fecha: fechaActual, datos: fechaPulse });
       fechaPulse=[];
       fechaActual=element.fechaCertificar;
       // fechaPulse.push(element);
       fechaPulse.push(datosPulsechek);
     }
   }
   else{
     datosPulsechek={
       completoCertificar: element.completoCertificar,
       fechaLanzamiento: element.fechaLanzamiento,
       fechaCertificar: element.fechaCertificar,
       idPlantilla: element.idPlantilla,
       idCertificar: element.idCertificar,
       idSurvey: element.idSurvey,
       tokenConfig: element.tokenConfig,
       btnPortalConteos:this.btnPortalConteos,
       numPulse:element.numPulse,
       encuestaActiva:element.openSurvey,
       nameSurvey:element.nameSurvey,
     }
     fechaActual=element.fechaCertificar;
     // fechaPulse.push(element);
     fechaPulse.push(datosPulsechek);
   }
   fechaPulse.sort( (a,b) => {
     if(a.numPulse > b.numPulse){ return 1; } else{ return -1; }
   });
   if(pulseV3.length ==(i+1)){
     this.aniosPulsecheck.push({fecha: element.fechaCertificar, datos: fechaPulse});
   }

     });
     this.cargando=false;
     console.log(this.aniosPulsecheck);
     let datos :any;
     this.aniosPulsecheck.forEach(element => {
       if (element.fecha== this.anioseleccionado) {
         datos=element.datos;
       }

     });
this.mostrarEncuestasFocus3=datos;
     console.log('datos correctos',datos);

   }

   openDialogCreaEncues(): void {

     let dataModal: any;
     const dialogRef = this.dialog.open(ModalAgregarEncComponent, {
       width: '40%',
       height: '50%',
       disableClose: true,
     });
     dialogRef.afterClosed().subscribe(result => {
       console.log('result',result);

       if (result==1) {
         console.log('entro este visne x1 ');
        this.getProductsByCompany();
       }else{
         console.log('entro este visne x2 ');

       }


     });
   }



}
